import styled from 'react-emotion'

import { colours, spacers } from '../../theme'

const Image = styled('div')`
	background-color: ${props => (props.colour ? props.colour : colours.light)};
	margin-bottom: 1rem;
	padding: ${spacers['5']} 0;
	&>img {
		margin: 0 auto;
		height: 150px;
		max-width: 90%;
		width: auto;
	}
`

export default Image
